"use strict";

/**
 * Load video from the HTML with `data-onload="js:FlixVideo.setup||12345` statement
 * 
 * @method FlixVideo.getViewCount()
 * @see FlixVideo.setup to start debugging
 * @event flix:video:ready
 * @example document.addEventListener('flix:video:ready', (e) => onPlayerReady(e.detail.player, e.detail.vid));
 */
var FlixVideo = function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  var FlixVideo = {};
  var vid = null;
  var player = null;
  var started = false;
  var viewCountKey = 'video_view_count_session';
  function onPageLoad() {
    // Clear Plyr instance when we visit non-video page (and reset on video page)
    FlixVideo.clearPlayer();
    vid = null;

    /** Clear Plyr for pre-rolls as well (and check first that it's loaded - not blocked by adblock) */
    if (typeof FlixPreroll != 'undefined') {
      FlixPreroll.clearPlayer();
    }

    // Check that it's a page with video placeholder that should
    // be replaced with video player
    var el = document.querySelector('#video-player');
    if (!el) {
      return;
    }
    vid = el.getAttribute('data-vid');
    if (!vid) {
      FlixStats.increment('video_setup_vid_is_empty');
      return;
    }
    if (typeof Plyr === 'undefined') {
      // if  has slow connection and plyr script not loaded yet
      document.addEventListener('flix:plyr', function () {
        return FlixVideo.setup(vid);
      });
    } else {
      FlixVideo.setup(vid);
    }
  }

  /**
   * Setup HTML video container.
   * Show preroll if needed.
   * 
   * @param {int} videoId 
   */
  FlixVideo.setup = function (videoId) {
    /** If url contains "?play=1" then video or preroll started automatically */
    var autoPlay = window.location.search.indexOf('play=1') != -1;
    if (FlixPreroll.isShouldShow()) {
      FlixPreroll.show(autoPlay);
    } else {
      FlixVideo.initPlayer(autoPlay);
    }
  };

  /**
   * Also invoked in init.js for cases when it's not a video page and `setupPlayer()` not called
   */
  FlixVideo.clearPlayer = function () {
    if (typeof Plyr != 'undefined' && player instanceof Plyr) {
      player.destroy();
      player = null;
    }
  };

  /**
   * All logic that happens when video `play` event triggered
   * @param {Event} e 
   */
  function onPlay(e) {
    if (Flix.requireAgeVerification && !Flix.ageVerified) {
      player.pause();
      Flix.ads.enabled = false;
      FlixUtils.initAge();
      return;
    }
    if (!started) {
      started = true;
      // Update view counter
      sessionStorage.setItem(viewCountKey, FlixVideo.getViewCount() + 1);

      // Add video to history and update num views
      FlixUtils.request(Flix.urlLangPrefix + '/ajax/on-video-play/' + vid, {
        method: 'POST'
      })["catch"](function (err) {
        console.error(err);
        FlixErrorLogger.log(err, 'video_on_play');
      });
    }
  }
  ;

  /**
   * API method to call from other places
   */
  FlixVideo.playVideo = function () {
    if (player) {
      player.play();
    }
  };

  /**
   * API method to call from other places
   */
  FlixVideo.pauseVideo = function () {
    if (player) {
      player.pause();
    }
  };

  /**
   * Initialize Plyr instance
   * @param {boolean} autoPlay if video should start playing after initialization
   */
  FlixVideo.initPlayer = function () {
    var autoPlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var videoPlayerEl = document.querySelector('#video-player');
    var mosaicBaseUrl = videoPlayerEl === null || videoPlayerEl === void 0 ? void 0 : videoPlayerEl.getAttribute('data-mosaic');
    player = new Plyr('#video-player', {
      controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'settings', 'airplay', 'fullscreen'],
      settings: ['quality'],
      keyboard: {
        focused: true,
        global: true
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true,
        container: null
      },
      // clickToPlay: !FlixUtils.isMobile(), // disable on mobile to prevent conflicts with double-click seek
      duration: videoPlayerEl === null || videoPlayerEl === void 0 ? void 0 : videoPlayerEl.getAttribute('data-duration'),
      previewThumbnails: {
        enabled: true,
        src: getVttThumbs(mosaicBaseUrl)
      }
    });
    player.speed = 1;
    player.on('play', onPlay);
    player.on('ready', function () {
      document.dispatchEvent(new CustomEvent('flix:video:ready', {
        detail: {
          player: player,
          vid: vid
        }
      }));

      // Add double-click seek functionality on mobile
      // if (FlixUtils.isMobile()) {
      //     setupDoubleClickSeek();
      //     setupMobileTextSelectionPrevention();
      // }

      if (autoPlay) {
        player.play();
      }
    });

    // Force landscape orientation in fullscreen mode on mobile
    // player.on('enterfullscreen', async () => {
    //     try {
    //         if (screen.orientation && screen.orientation.lock) {
    //             await screen.orientation.lock('landscape');
    //         }
    //     } catch (err) {
    //     }
    // });

    // player.on('exitfullscreen', () => {
    //     if (screen.orientation && screen.orientation.unlock) {
    //         screen.orientation.unlock();
    //     }
    // });
  };

  /**
   * Return number of video views during this session
   * @returns int
   */
  FlixVideo.getViewCount = function () {
    var counter = parseInt(sessionStorage.getItem(viewCountKey));
    return isNaN(counter) ? 0 : counter;
  };

  /**
   * Setup double-click seek functionality on video player edges (mobile only)
   */
  function setupDoubleClickSeek() {
    var videoContainer = document.querySelector('#video-player-container');
    if (!videoContainer) return;
    var SEEK_SECONDS = 10;

    // Prevent text selection on mobile browsers
    var preventSelection = function preventSelection(e) {
      e.preventDefault();
      return false;
    };

    // Add event listeners to prevent text selection
    videoContainer.addEventListener('selectstart', preventSelection, {
      ive: false
    });
    videoContainer.addEventListener('dragstart', preventSelection, {
      ive: false
    });
    videoContainer.addEventListener('contextmenu', preventSelection, {
      ive: false
    });

    // Prevent selection on touch events (mobile specific)
    videoContainer.addEventListener('touchstart', function (e) {
      // Allow the touch event but prevent any selection behavior
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
    }, {
      ive: true
    });
    videoContainer.addEventListener('touchend', function (e) {
      // Clear any selection that might have occurred
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
    }, {
      ive: true
    });

    // Handle double-click behavior on mobile - prevent fullscreen completely
    videoContainer.addEventListener('dblclick', function (e) {
      // Only handle double-clicks on the video area, not controls
      if (e.target.closest('.plyr__controls') || e.target.closest('.plyr__menu')) {
        return;
      }

      // Always prevent fullscreen on mobile (use capture phase to intercept before Plyr)
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Clear any text selection that might have occurred
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
      if (document.selection) {
        document.selection.empty(); // IE fallback
      }
      var rect = videoContainer.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      var containerWidth = rect.width;
      var edgeThreshold = containerWidth * 0.3;
      if (clickX < edgeThreshold || clickX > containerWidth - edgeThreshold) {
        // Perform seek operation on edges
        if (player && player.duration && player.duration > 0) {
          if (clickX < edgeThreshold) {
            // Left edge - seek backward
            var newTime = Math.max(0, player.currentTime - SEEK_SECONDS);
            player.currentTime = newTime;
            showSeekIndicator('backward', SEEK_SECONDS);
          } else {
            // Right edge - seek forward
            var _newTime = Math.min(player.duration, player.currentTime + SEEK_SECONDS);
            player.currentTime = _newTime;
            showSeekIndicator('forward', SEEK_SECONDS);
          }
        }
      }
      // For center area double-clicks, do nothing (no fullscreen)
    }, true); // Use capture phase to prevent Plyr from handling double-clicks
  }

  /**
   * Show visual  for seek operation
   * @param {string} direction - 'forward' or 'backward'
   * @param {number} seconds - number of seconds seeked
   */
  function showSeekIndicator(direction, seconds) {
    // Use the appropriate container based on fullscreen state
    var container = document.querySelector('#video-player-container');

    // If in fullscreen, try to find the fullscreen container
    if (player.fullscreen.active) {
      var fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
      if (fullscreenElement) {
        container = fullscreenElement;
      }
    }
    if (!container) return;

    // Remove existing indicator
    var existingIndicator = container.querySelector('#dbclick-seek-indicator');
    if (existingIndicator) {
      existingIndicator.remove();
    }

    // Create new indicator
    var indicator = document.createElement('div');
    indicator.id = 'dbclick-seek-indicator';
    indicator.className = "fade-indicator ".concat(direction);
    indicator.innerHTML = "\n            <div>".concat(direction === 'forward' ? '+' : '-').concat(seconds, "s</div>\n            <div class=\"seek-arrow ").concat(direction === 'forward' ? 'forward' : 'backward', "\">\n                ").concat(direction === 'forward' ? '&gt;&gt;' : '&lt;&lt;', "\n            </div>\n        ");
    container.appendChild(indicator);
  }

  /**
   * Setup additional mobile-specific text selection prevention
   */
  function setupMobileTextSelectionPrevention() {
    var videoContainer = document.querySelector('#video-player-container');
    if (!videoContainer) return;

    // Additional mobile-specific prevention
    var preventTextSelection = function preventTextSelection() {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
      if (document.selection) {
        document.selection.empty();
      }
    };

    // Clear selection periodically during touch interactions
    var touchTimeout;
    videoContainer.addEventListener('touchstart', function () {
      clearTimeout(touchTimeout);
      touchTimeout = setTimeout(preventTextSelection, 10);
    }, {
      ive: true
    });
    videoContainer.addEventListener('touchmove', function () {
      clearTimeout(touchTimeout);
      touchTimeout = setTimeout(preventTextSelection, 10);
    }, {
      ive: true
    });
    videoContainer.addEventListener('touchend', function () {
      clearTimeout(touchTimeout);
      setTimeout(preventTextSelection, 50); // Slight delay to catch any lingering selection
    }, {
      ive: true
    });
  }
  var vttCache = {};
  function getVttThumbs(mosaicBaseUrl) {
    var videoPlayerEl = document.querySelector('#video-player');
    var duration = parseFloat(videoPlayerEl === null || videoPlayerEl === void 0 ? void 0 : videoPlayerEl.getAttribute('data-duration'));
    if (!duration || isNaN(duration)) return '';
    var cacheKey = "".concat(mosaicBaseUrl, "|").concat(duration);
    if (vttCache[cacheKey]) return vttCache[cacheKey];
    var vtt = 'WEBVTT\n\n';
    if (Flix.site === 'empflix') {
      // Empflix: 30 thumbs, 1.jpg to 30.jpg
      var totalThumbs = 30;
      var interval = duration / totalThumbs;
      for (var i = 1; i <= totalThumbs; i++) {
        var start = (i - 1) * interval;
        var end = Math.min(start + interval, duration);
        var timeFormat = function timeFormat(s) {
          return new Date(s * 1000).toISOString().substr(11, 12);
        };
        vtt += "".concat(timeFormat(start), " --> ").concat(timeFormat(end), "\n");
        vtt += (mosaicBaseUrl === null || mosaicBaseUrl === void 0 ? void 0 : mosaicBaseUrl.replace('#', i)) + '\n\n';
      }
    } else {
      // Tnaflix: sprite logic
      var thumbsPerSprite = 25;
      var columns = 5;
      var thumbWidth = 200;
      var thumbHeight = 100;
      // Dynamic algorithm (matches Python compute_dynamic_thumbs)
      var numThumbs;
      if (duration < 600) {
        numThumbs = 75;
      } else if (duration > 5000) {
        numThumbs = 500;
      } else {
        numThumbs = Math.floor((duration - 600) * 425 / 4400 + 75);
      }
      var _totalThumbs = numThumbs;
      var spriteCount = Math.ceil(_totalThumbs / thumbsPerSprite);
      var _interval = duration / _totalThumbs;
      var thumbIndex = 0;
      for (var sprite = 0; sprite < spriteCount; sprite++) {
        var url = mosaicBaseUrl === null || mosaicBaseUrl === void 0 ? void 0 : mosaicBaseUrl.replace('#', sprite);
        for (var _i = 0; _i < thumbsPerSprite && thumbIndex < _totalThumbs; _i++, thumbIndex++) {
          var _start = thumbIndex * _interval;
          var _end = Math.min(_start + _interval, duration);
          var col = _i % columns;
          var row = Math.floor(_i / columns);
          var x = col * thumbWidth;
          var y = row * thumbHeight;
          var _timeFormat = function _timeFormat(s) {
            return new Date(s * 1000).toISOString().substr(11, 12);
          };
          vtt += "".concat(_timeFormat(_start), " --> ").concat(_timeFormat(_end), "\n");
          vtt += "".concat(url, "#xywh=").concat(x, ",").concat(y, ",").concat(thumbWidth, ",").concat(thumbHeight, "\n\n");
        }
      }
    }
    var blobUrl = URL.createObjectURL(new Blob([vtt], {
      type: 'text/vtt'
    }));
    vttCache[cacheKey] = blobUrl;
    return blobUrl;
  }
  return FlixVideo;
}();